import { Theme, useStyles } from 'bold-ui'
import { DateTime } from 'components/date'
import { CheckboxField } from 'components/form'
import React, { CSSProperties } from 'react'
import { MetaPath } from 'util/metaPath'

import { AgendamentosDiaFieldModel } from './AgendamentosDiaField'

export interface AgendamentosDiaCheckFieldProps {
  name: MetaPath<string>
  agendamento: AgendamentosDiaFieldModel
}

export function AgendamentosDiaCheckField(props: AgendamentosDiaCheckFieldProps) {
  const { classes } = useStyles(createStyles)
  const { name, agendamento } = props

  const agendamentosDiaLabelRender = (name: string, time: string) => {
    return (
      <div
        style={{
          fontWeight: 'bold',
          marginLeft: '0.5rem',
        }}
      >
        <DateTime value={time} format='HH:mm' />
        {' - ' + name}
      </div>
    )
  }

  return (
    <CheckboxField
      style={classes.AgendamentosDiaCheck}
      label={agendamentosDiaLabelRender(agendamento.lotacaoAgendada.profissional.nome, agendamento.horarioInicial)}
      name={name}
      value={agendamento.id}
    />
  )
}

const createStyles = (theme: Theme) => ({
  AgendamentosDiaCheck: {
    width: '100%',
    background: theme.pallete.surface.main,
    padding: '1.25rem 1rem 1.25rem 0.75rem',
    borderRadius: '2px',
    border: `1px solid ${theme.pallete.gray.c60}`,
  } as CSSProperties,
})
